import { createElement } from "react";

// React.lazy-variant die vooraf geladen kan worden: na preload() rendert de component synchroon (geen Suspense-fallback).
export function lazyPreloadable(factory) {
  let mod = null;
  let pending = null;
  const preload = () => {
    if (mod) return Promise.resolve(mod);
    if (!pending) {
      pending = factory().then((m) => {
        mod = m.default;
        return mod;
      });
    }
    return pending;
  };
  const Lazy = (props) => {
    if (mod) return createElement(mod, props);
    throw preload();
  };
  Lazy.preload = preload;
  return Lazy;
}
